import appLocaleData from 'react-intl/locale-data/zh';
import antdZhCN from 'antd/lib/locale-provider/zh_CN';

const zhMessages = {
	'App.datePicker.title': '选择日期',
	'InjectExample.alert': '弹出框',
	'InjectExample.button': '弹出按钮',
	'InjectExample.description': '描述'
};
window.appLocale = {
	messages: {
		...zhMessages,
	},
	antd: antdZhCN,
	locale: 'zh-CN',
	data: appLocaleData,
};
